export default "__VITE_ASSET__a98b4c02__"